export default {
  RemoveItemGroup: 'Remove Item Group',
  RemoveItemFeature: 'RemoveItemFeature',
  NewItemGroupAdd: 'New Item Group Add',
  ItemGroupUpdate: 'Item Group Update',
  NewItemAdd: 'New Item Add',
  ItemUpdate: 'Item Update',
  ItemFeatureUpdate: 'Item Feature Update',
  NewItemFeatureAdd: 'New Item Feature Add',

  Information: 'Information',
  Image: 'image',
  Feature: 'Featur',
  Dimension: 'Dimension',
  DimensionItem: 'Dimension Item',
  Size: 'Size',
  Interval: 'Interval',
  Enable: 'Enable',
  Disable: 'Disable',
  FloorSensitive: 'Floor Sensitive',
  Item: 'Item',
  HeightThreshold: 'Height Threshold',
  Height: 'Height',
  Length: 'Length',
  LengthThreshold: 'Length Threshold',
  Width: 'Width',
  WidthThreshold: 'width Threshold',
  NoThreshold: 'No Threshold',
  Threshold: 'Threshold',
  Weight: 'weight',
  Amount: 'Amount',
  Order: 'Order',
  Others: 'Others',
  Unit: 'Unit',
  Slug: 'Slug',
  ItemGroup: 'Item Group',
  Description: 'Description',
}